import { css } from '@emotion/css';

export const nextButtonContainerStyle = css`
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 0;

    img {
        width: 450px;
    }
`;

export const defaultImageContainer = (bgColor?: string) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${bgColor ?? 'transparent'};

    > img {
        width: 1260px;
        height: auto;
    }
`;
